import React from 'react';
import './FAQs.scss';

export class FAQs extends React.Component {
  public render(): JSX.Element {
    return (
      <div className="faq-wrapper">
        <div className="background"/>
        {/* <Breadcrumbs
          onHomeClick={() => navigateTo('/home')}
          onRedirect={navigateTo}
          segments={breadcrumbs} \\ Need to add breadcrumbs
        /> */}
        <section className="heading-wrapper">
          <h1>FAQs</h1>
        </section>
      </div>
    );
  }
}
